import getNotesEditorViewState from '../selectors/getNotesEditorViewState';

export function getNotesEditorResponseType(id: string) {
    const viewState = getNotesEditorViewState(id);
    return viewState ? viewState.responseType : undefined;
}
